import React, { FC } from 'react'
import { Trans } from 'react-i18next'
import utils from '../../../../../components/Organisms/Form/utils'
import config from './config'
import t from '../../../../../translations/main'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'

import Button from '../../../../../components/Atoms/Button/Button'

import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormDescription,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
} from '../../../../../components/Organisms/Form/Form.styles'
import { FormProps } from '../../../../Pages/Onboarding/types'

const IndividualExperienceForm: FC<FormProps> = props => {
  const submitForm = (data: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit(data)
  }

  const { formData, emptyValidation, handleInputChange, handleSubmit } =
    useForm(props.fetchedData, config, submitForm)

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>{t('onboarding.forms.IndividualAccount.ExperienceForm.title')}</FormTitle>
        <FormDescription>
          {/* @ts-ignore:next-line */}
          {<Trans i18nKey={'onboarding.forms.IndividualAccount.ExperienceForm.description'} />}
        </FormDescription>
      </FormHeader>
      {utils.sectionBuilder(config, formData, handleInputChange)}
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          {!props.disablePrev && (
            <Button label={t('onboarding.main.backButton')} version={2} disabled={props.disablePrev} />
          )}
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={emptyValidation}
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default IndividualExperienceForm
